import { StringColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	ifscCode: 'ifscCode',
	accountNumber: 'accountNumber',
	accountHolderName: 'accountHolderName',
	validatedAccountHolderName: 'validatedAccountHolderName',
	crmAliasName: 'crmAliasName'
};

export const columnConfigs = [
	StringColumn({
		title: 'Account number',
		mapDataToValue: (data: any) => data[COL_NAMES.accountNumber] || EMPTY_STRING
	}),
	StringColumn({
		title: 'IFSC code',
		mapDataToValue: (data: any) => data[COL_NAMES.ifscCode] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Account holder name',
		mapDataToValue: (data: any) => data[COL_NAMES.accountHolderName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Validated account holder name',
		mapDataToValue: (data: any) => data[COL_NAMES.validatedAccountHolderName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'CRM alias name',
		mapDataToValue: (data: any) => data[COL_NAMES.crmAliasName] || EMPTY_STRING
	})
];
